import React from "react";

const Logo = () => {
  return <div className="text-cyan-400 text-4xl font-bold">denthut</div>;
};

export default Logo;
